import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';

const MtargGraph = ({ percentageData }) => {
  const [percentage, setPercentage] = useState(0);

  useEffect(() => {
    if (percentageData) {
      setPercentage(percentageData.mTarg);
    }
  }, [percentageData]);

  const options = {
    chart: {
      height: 300,
      type: 'radialBar',
      animations: {
        enabled: true,
        easing: 'easeinout',
        speed: 800,
      },
      dropShadow: {
        enabled: true,
        top: 2,
        left: 2,
        blur: 1,
        opacity: 0.2,
      },
    },
    plotOptions: {
      radialBar: {
        hollow: {
          size: '60%',
          
        },
        track: {
          background: '#98C7FF', // Darker shade for the underside of the outer circle
          strokeWidth: '100%',
          opacity: 1,
          margin: 5, // margin is in pixels
          dropShadow: {
            enabled: true,
            top: 5,
            left: 5,
            blur: 8,
            opacity: 0.7,
            color: '#114686',

          },
        },
        dataLabels: {
          name: {
            offsetY: -10,
            show: false,
            color: '#757FD5',
            fontSize: '14px',
            fontWeight: 'bold',
          },
          value: {
            offsetY: 5,
            fontSize: '24px',
            color: '#114686',
            fontWeight: 'bold',
            formatter: (val) => `${val}%`,
          },
        },
      },
    },
    fill: {
      type: 'solid',
      
      colors: ['#114686'],
    },
    stroke: {
      lineCap: 'round',
    },
    // labels: ['Incoming Moisture'],
  };

  const series = [percentage];

  return (
    <div>
        <h3 className="text-xl font-semibold lg:text-xl mb-2 text-[#114686]">Target Moisture</h3>
      <ReactApexChart options={options} series={series} type="radialBar" height={300} />
    </div>
  );
};

export default MtargGraph;